// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-management-container[data-v-471848ec]{padding:20px}.header-card[data-v-471848ec],.search-card[data-v-471848ec]{margin-bottom:20px}.el-tag[data-v-471848ec]{margin:2px}@media (max-width:768px){.user-management-container[data-v-471848ec]{padding:10px}.el-dialog[data-v-471848ec]{width:90%!important}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
